import { render } from "./AppBase.vue?vue&type=template&id=00c54552&scoped=true&ts=true"
import script from "./AppBase.vue?vue&type=script&lang=ts"
export * from "./AppBase.vue?vue&type=script&lang=ts"

import "./AppBase.vue?vue&type=style&index=0&id=00c54552&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c54552"]])

export default __exports__